export default "https://cdn.cloudgame-br.qcloud.com/static/prod/dist/img/yunyin.1f7ad7277490cd12b209fca7ce62b5a6.webp";